import React, { useEffect } from "react";
import { createListTableColumns, GroupedDetailsList } from "sprint-common-web";

import { AncillaryContentSubtype } from "../../../common/types/AncillaryContentType";
import { renderAssetTypes } from "../../../common/utils/renderAssetType";
import { getAncillaryAssetsListHref } from "../../AssetsRoutes";
import { AncillarySearchItem } from "./AncillarySearchItem";
import { useAncillarySearchListPage } from "./useAncillarySearchListPage";

export interface AncillarySearchListPageProps {
    query: string;
    ancillaryContentType: AncillaryContentSubtype;
    types: number[];
}

export const AncillarySearchListPage: React.FC<AncillarySearchListPageProps> = (
    props: AncillarySearchListPageProps
) => {
    const { query, ancillaryContentType, types } = props;

    const { items, totalCount, isLoading, isMoreLoading, pageSize, search, loadMore } = useAncillarySearchListPage();

    useEffect(() => {
        search({ query, ancillaryContentType, types });
    }, [query, ancillaryContentType, types]);

    const columns = createListTableColumns<AncillarySearchItem>([
        {
            type: "link",
            key: "title",
            name: "Title",
            minWidth: 300,
            maxWidth: 400,
            getHref: (item) => getAncillaryAssetsListHref(item.id)
        },
        {
            type: "basic",
            key: "distributor",
            name: "Distributor",
            minWidth: 150,
            maxWidth: 650
        },
        {
            type: "basic",
            key: "types",
            name: "Type",
            minWidth: 100,
            maxWidth: 250,
            onRender: renderAssetTypes
        },
        {
            type: "basic",
            key: "assetsCount",
            name: "Active assets count",
            minWidth: 100,
            maxWidth: 100
        }
    ]);

    return (
        <GroupedDetailsList
            items={items}
            totalItemsCount={totalCount}
            columns={columns}
            isLoading={isLoading}
            loadMoreProps={{ isMoreLoading, pageSize, onLoadMoreClick: loadMore }}
        />
    );
};
